import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid, Box, Divider } from '@mui/material'

// ICONOS
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BadgeIcon from '@mui/icons-material/Badge';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import EditIcon from '@mui/icons-material/Edit';

const AtenderAlerta = ({ open, onClose, data }) => {

    return (

        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
        >

            <DialogTitle>{data?.subject}</DialogTitle>

            {/* BODY */}

            <DialogContent>

                <Grid 
                    container 
                    spacing={2} 
                    marginTop={1} 
                    sx={{ 
                        maxHeight: '80vh', 
                        overflow: 'auto',
                        mb: 2,
                        mt: 2,
                        p: 2
                    }}
                >

                    <Grid size={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <AnnouncementIcon />
                            <strong>Tipo de Evento:</strong><br />
                        </Box>
                        {data?.event_type || '--'}
                    </Grid>

                    <Grid size={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <LocalShippingIcon />
                            <strong>Camión:</strong>
                        </Box>
                        {data?.truck || '--'}
                    </Grid>

                    <Grid size={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <BadgeIcon />
                            <strong>Conductor:</strong><br />
                        </Box>
                        {data?.driver_name || '--'}
                    </Grid>

                    <Grid size={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <BadgeIcon />
                            <strong>ID del Conductor:</strong><br />
                        </Box>
                        {data?.driver_id || '--'}
                    </Grid>

                    <Grid size={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <CalendarMonthIcon />
                            <strong>Fecha de Evento:</strong><br />
                        </Box>
                        {data?.event_date || '--'}
                    </Grid>

                    <Grid size={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <CalendarMonthIcon />
                            <strong>Fecha de Cierre:</strong><br />
                        </Box>
                        {data?.end_date || '--'}
                    </Grid>

                    <Grid size={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <PendingActionsIcon />
                            <strong>Tiempo de Respuesta:</strong><br />
                        </Box>
                        {data?.tiempo_respuesta || '--'}
                    </Grid>

                    <Grid size={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <AccountCircleIcon />
                            <strong>Atendido por:</strong><br />
                        </Box>
                        {data?.attended_by || '--'}
                    </Grid>

                    <Grid size={12}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <EditIcon />
                            <strong>Solución:</strong><br />
                        </Box>
                        <Divider sx={{ pb: 1, mb: 1 }} />
                        {data?.solution || '--'}
                    </Grid>

                </Grid>

            </DialogContent>

            <DialogActions
                sx={{ justifyContent: 'center' }}
            >

                <Button onClick={onClose}>Cancelar</Button>

            </DialogActions>

        </Dialog>

    )

}

export default AtenderAlerta